import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import _ from "lodash";
import Select from "react-select";
import { Field, reduxForm } from "redux-form";
import moment from "moment";
import "./styles.css";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import Util from '../../../../Common/util';
import API from '../../../../Common/api';
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";

var url = window.location.hostname;
var port = window.location.port;

function createCookie(cookieName, cookieValue, daysToExpire) {
  var date = new Date();
  date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
  document.cookie =
    cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
}

function accessCookie(cookieName) {
  var name = cookieName + "=";
  var allCookieArray = document.cookie.split(";");
  for (var i = 0; i < allCookieArray.length; i++) {
    var temp = allCookieArray[i].trim();
    if (temp.indexOf(name) == 0)
      return temp.substring(name.length, temp.length);
  }
  return "";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const options = {
  textLabels: {
    body: {
      noMatch: "Data is Loading...",
    },
  },
  selectableRows: false,
  sort: false,
  download: false,
  print: false,
  viewColumns: false,
  filter: false,
  pagination: true,
  search: true,
  setRowProps: (row) => {},
  onCancel: false,
  task_id:"",
};

class HorizontalForm extends PureComponent {
  state = {
	Successmodal: false,
    data_for_consolidation: [],
    consolidation_response: [],
    data_for_task: [],
    userName: "",
    selectedLocation: "",
    showBinConsolidationTable: false,
    modalAssignUser: false,
    options: [],
    showZone: false,
    selected_zone_option: [],
    showTaskTable: true,
    selected: {},
    selected_all: false,
    selectedUser: {},
    optionsUser: [],
    uniqueZoneData: {},
    DisableAssignbutton: true,
	reasonText: null,
    createTaskBtnDisabled: false,
    showPendingNote: false,
  };

  fetchUserList = () => {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/auth/users/getusers', { param: payload })
      .then((response) => {
        let optionsUser = [...this.state.optionsUser];
        for (var i = 0; i < response.data.length; i++) {
          // <---- Move declaration inside loop

          var orderData = {};
          orderData["label"] = response.data[i].userName;
          orderData["value"] = response.data[i].userId;

          optionsUser.push(orderData);
        }
        this.setState({
          optionsUser: optionsUser,
        });
      })
      .catch(function (error) {});
  };

  onChangeValStock = (options, id, bin_items) => {
    const { selectedUser } = this.state;
    /*selectedUser[id] = options.map(item => [item.value])*/
    var data = [];
    for (var i = 0; i < options.length; i++) {
      data.push(options[i]["value"]);
    }
    selectedUser[id] = [];
    selectedUser[id].push(data);
    selectedUser[id].push(bin_items);
    this.setState({
      selectedUser,
    });
  };

  onChangeVal = (options, id) => {
    const { selectedUser } = this.state;

    selectedUser[id] = options;
    this.setState({
      selectedUser,
    });
  };
  
  StatusClickHandler = (batch_id,request_type) => {
    localStorage.setItem("batch-id",batch_id);
    const payload = {
      location: this.state.selectedLocation,
      batch_id: batch_id,
  request_type: 1
  };

API.post('/maintenance/fetchBinConsolidationTasks/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        if(data.status === false){
			this.setState({
				showZone: false,
				showBinConsolidationTable: false,
				reasonText: data.reason,
				Successmodal: true,
			});
		}
        let updated_data = data.map((row, index) => {
          var checkbox_classname = "checkbox_div checkbox_" + index;
          var checkbox_html = (
            <input
              type="checkbox"
              className={checkbox_classname}
              name={index}
              selected={this.state.selected[checkbox_classname]}
              onChange={this.handleCheckBoxClick}
              style={{ opacity: "0.85" }}
            />
          );

          return {
            checkbox: checkbox_html,
            lb_sku_id: row["lb_sku_id"],
            lb_sku_product_name: row["product_description"],
            pkd: row["pkd"],
            cbu_code: row["cbu_code"],
            mrp: row["mrp"],
            bin_count: row["total_bins_occupied"],
			used_capacity: row["estimated_released_bins"],
          };
        });
		
		let updated_data_2 = data.map((row, index) => {
          return {
            lb_sku_id: row["lb_sku_id"],
            product_description: row["product_description"],
            cbu_code: row["cbu_code"],
            pkd: row["pkd"],
			id: row["id"],
            batch_id: row["batch_id"],
          };
        });

        this.setState({
          data_for_consolidation: updated_data,
          consolidation_response: updated_data_2,
          showZone: false,
		  showBinConsolidationTable: true,
        });
      })
      .catch(function (error) {});
  };
  ShowCreatedTask = () => {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/maintenance/binConsolidationdashboard/v1/', { param: payload })
      .then((response) => {
        let taskdata = [];
        let createTaskBtnDisabled = false;
        let showPendingNote = false;
        for (let i = 0; i < response.data.length; i++) {

		  let status = "";
		  let id = response.data[i]["id"];
          var print = <p style={{cursor: "not-allowed"}}>Print</p>;
		  if(parseInt(response.data[i]["status"]) == 0){
            createTaskBtnDisabled = true;
            showPendingNote = true;
			status = <span style={{ color: "orange", fontWeight: "bold" }}>Processing</span>
            id = response.data[i]["id"];
		  }else if(parseInt(response.data[i]["status"]) == 1){
            createTaskBtnDisabled = true;
            showPendingNote = true;
			status = <span style={{ color: "red", fontWeight: "bold" }}>Selection Pending</span> 
			id = <a
                style= {{ cursor: "pointer", color: "rgb(62, 163, 252)" }}
                onClick={() => {this.StatusClickHandler(response.data[i]["id"],1)}}
              >{response.data[i]["id"]}</a>;
		  }else if(parseInt(response.data[i]["status"]) == 2){
            createTaskBtnDisabled = true;
            showPendingNote = true;
			status = <span style={{ color: "red", fontWeight: "bold" }}>Confirmation Pending</span> 
			id = <a
                style={{ cursor: "pointer", color: "rgb(62, 163, 252)" }}
                onClick={() => this.TaskConfirmClick(response.data[i]["id"])}
		  >{response.data[i]["id"]}</a>;
            print = <a
                style={{ cursor: "pointer", color: "rgb(62, 163, 252)" }}
                onClick={() => this.printData(response.data[i]["id"])}
		  >Print</a>;
		  }else if(parseInt(response.data[i]["status"]) == 111){
			status = <span style={{ color: "red", fontWeight: "bold" }}>Cancelled</span> 
			id = response.data[i]["id"];
		  }else if(parseInt(response.data[i]["status"]) == 3){
			status = <span style={{ color: "green", fontWeight: "bold" }}>Completed</span>
			id = response.data[i]["id"];
		  }else if(parseInt(response.data[i]["status"]) == 222){
			status = <span style={{ color: "green", fontWeight: "bold" }}>NO Candidate</span>
			id = response.data[i]["id"];
		  }
          taskdata.push({
			/*cancel: parseInt(response.data[i]["status"]) == 0 ? (
				<span onClick={() => this.setTaskID(response.data[i]["id"])}
				class="lnr lnr-cross"
				style={{ color: "red", fontWeight: "bold" }}
				></span>
				) : (
					<span></span>
				),*/
            id: id,
			status: status,
			date: response.data[i]["date"],
			tasks_recommended: response.data[i]["tasks_recommended"],
            tasks_generated: response.data[i]["tasks_generated"],
            product_recommended: response.data[i]["recommended_product"],
            product_selected: response.data[i]["selected_product"],
			print: print,
          });
        }
        this.setState({
          data_for_task: taskdata,
		  onCancel : false,
          createTaskBtnDisabled: createTaskBtnDisabled,
        });
      })
      .catch(function (error) {});
  };

  TaskConfirmClick = (id) => {
    localStorage.setItem("tableRowsGRN","");
	localStorage.setItem("updatedClickedRow","");
	localStorage.setItem("allSelectedReason","")
    localStorage.setItem('batch-id',id);window.location.href = "/maintenance/BinconsolidationConfirmation";
  };

  showZoneDropdown = () => {
    this.setState({ 
		showZone: !this.state.showZone,
		selected_zone_option : "",
	});
  };
  /*createTaskForConsolidation = () => {
    axios
    .post(
        "http://" + url + "/picking/splitPutaway/v1/",
        {
          location: this.state.selectedLocation,
        },

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.state.userName,
          },
        }
      )
      .then((response) => {})
      .catch(function (error) {});
  };*/

  zoneDropdown = () => {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/cycle_count/cycleCountParameters/v1/', { param: payload })
      .then((response) => {
        let options = [...this.state.options];
        for (var i = 0; i < response.data.zones.length; i++) {
          var orderData = {};
          orderData["label"] = response.data.zones[i].zone_code;
          orderData["value"] = response.data.zones[i].zone_no;
          orderData["id"] = response.data.zones[i].id;
          if(response.data.zones[i].zone_code !== "Testers"){
              options.push(orderData);
		  }
        }
        this.setState({
          options: options,
        });
      })
      .catch(function (error) {});
  };
  componentDidMount() {
    if (port == 8091 || port === ":8090") {
      port = ":8090";
    }else if (port == 8098 || port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = getCookie("token");
    var Location = getCookie("selectedLocation");
    var username = accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
      },
      () => {
        this.zoneDropdown();
        this.fetchUserList();
        this.ShowCreatedTask();
      }
    );

    localStorage.setItem("userName", username);
  }

  handleAssignButton = () => {
    this.setState({
      modalAssignUser: true,
    });
  };

  AssignButton = () => {
    this.setState({
      modalAssignUser: false,
      showZone: false,
      showBinConsolidationTable: false,
      showTaskTable: false,
    });
  };

  closeAssignModal = () => {
    const checkboxes = document.getElementsByClassName("checkbox_div");
    const selected = { ...this.state.selected };

    for (var i = 0; i < Object.keys(selected).length; i++) {
      if (selected[i] == true) {
        document.getElementsByName(checkboxes[i].name)[0].click();
      }
    }

    if (this.state.selected_all == true) {
      document.getElementsByName("select_all_checkbox")[0].click();
    }

    this.setState({
      modalAssignUser: !this.state.modalAssignUser,
      uniqueZoneData: [],
    });
  };

  handleCheckBoxClick = (e) => {
    const selected = this.state.selected;
    selected[e.target.name] = e.target.checked;

    this.setState({ selected }, () => {
      let checked = [];
	  let selected_checkbox = {...this.state.selected};
	  
      for (let i = 0; i < Object.keys(this.state.selected).length; i++) {
        if (selected_checkbox[ Object.keys(this.state.selected)[i]] == true) {
          checked.push(selected_checkbox[ Object.keys(this.state.selected)[i]]);
        }
      }
	  
      if (checked.length > 0) {
        this.setState({
          DisableAssignbutton: false,
        });
      } else {
        this.setState({
          DisableAssignbutton: true,
        });
      }
    });
  };

  handleallCheckBoxClick = (e) => {
    const selected_all = e.target.checked;
    const selected = this.state.selected;

    const checkboxes = document.getElementsByClassName("checkbox_div");
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].disabled == false) {
        if (checkboxes[i].checked != e.target.checked) {
          document.getElementsByName(checkboxes[i].name)[0].click();
        }
      }
    }

    this.setState({
      selected: selected,
    });

    this.setState({
      selected_all: selected_all,
    });
  };
  fetchAllProducts = () => {
    let zone_array = this.state.selected_zone_option.map((item) => item.id);
    const payload = {
      location: this.state.selectedLocation,
      zone_ids: zone_array,
  };

API.post('/maintenance/createBinConsolidationBatch/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        if(data.status === false){
			this.setState({
				showZone: false,
				showBinConsolidationTable: false,
				reasonText: data.reason,
				Successmodal: true,
			});
            return false;
		}else{
			this.setState({
			showZone: false,
			showBinConsolidationTable: true,
			}, () => {window.location.reload()});
		}
      })
      .catch(function (error) {});
  };

  getSelectedZones = (selectedzone) => {
    this.setState({
      selected_zone_option: selectedzone,
    });
  };

  printData = (batch_id) => {
    const payload = {
    
      location: this.state.selectedLocation,
      batch_id: batch_id,
  request_type: 2
  };

API.post('/maintenance/fetchBinConsolidationTasks/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        var printData = {};
        data.map(row => {
			if(Object.keys(printData).indexOf(row["username"].toString()) === -1){
				printData[row["username"].toString()] = [];
			}
			printData[row["username"]].push(row);
		});
        localStorage.setItem("printBinData",JSON.stringify(printData));
        localStorage.setItem("batch-id",batch_id);
		window.open("/print_bin_data", "_blank");
		
      })
      .catch(function (error) {});
  }
  createTaskForConsolidation = () => {
    let payloadArray = [];
    let printData = {};
    const uniqueZoneData = {};
    let selectedUserLength = {};

    let selectedItems = { ...this.state.selected };
    let batch_id = 0;
    Object.keys(selectedItems).map((index) => {
      if (selectedItems[index] == true) {
        var key =
          this.state.consolidation_response[index]["lb_sku_id"] +
          "_" +
          this.state.consolidation_response[index]["pkd"];

        if (this.state.selectedUser[key] != undefined) {
          //console.log("Checked Item", this.state.consolidation_response[index]);
          let item_per_user = parseInt(1 / this.state.selectedUser[key].length);

          let inc = 0;
          let userIndex = 0;

          let userId = this.state.selectedUser[key][userIndex]["value"];

          payloadArray.push({
            id: this.state.consolidation_response[index]["id"],
            user_id: userId,
          });
          /*var username = "wmsuser";
		  if(userId.toString() === "1"){ 
			username = "wmsuser";
			}else{
			username = "Rupesh";
			}
          if(Object.keys(printData).indexOf(username.toString()) === -1){
			printData[username] = [];
		  }
          printData[username.toString()].push(this.state.consolidation_response[index]);*/
          batch_id = this.state.consolidation_response[index]["batch_id"]
          inc++;
          if (inc % item_per_user == 0) {
            userIndex++;
          }

          if (!this.state.selectedUser[key][userIndex]) {
            userIndex = 0;
          }
        }
      }
    });
    //localStorage.setItem("printBinData",JSON.stringify(printData));
    
    const payload = {
      location: this.state.selectedLocation,
      batch_id: batch_id,
      recommended_ids: payloadArray,
  };

API.post('/maintenance/selectBinConsolidation/v1/', { param: payload })
      .then((response) => {
        this.setState({
          modalAssignUser: false,
          showZone: false,
          showBinConsolidationTable: false,
          showTaskTable: true,
        });
        this.ShowCreatedTask();
        this.printData(batch_id);
      })
      .catch(function (error) {});
  };

  Successtoggle = () => {
    this.setState({Successmodal: !this.state.Successmodal });
  }

  SuccesstoggleCancel = () => {
    this.setState({
        Successmodal: false
    })
  }

  onCancelHandler = () => {
    this.setState({
		onCancel: !this.state.onCancel,
	})
  }

  taskCancelHandler = () => {
    let task_ids_for_cancel = [];
    
    let batch_id = localStorage.getItem("batch-id");
    const payload = {
      location: this.state.selectedLocation,
      task_ids: task_ids_for_cancel,
      batch_id: batch_id,
      cancel_type: 0,
  };

API.post('/maintenance/cancelBinConsolidation/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        if(data.status === true){
            window.location.reload();
        }
      })
      .catch(function (error) {});
  };
  render() {
    const productData = {
      columns: [
        {
          label: (
            <input
              type="checkbox"
              name="select_all_checkbox"
              selected={false}
              onChange={this.handleallCheckBoxClick}
            />
          ),
          field: "checkbox",
          width: 100,
        },

        {
          label: "LBSKUID",
          field: "lb_sku_id",
          sort: "disabled",
          width: 100,
        },
        {
          label: "Product Description",
          field: "lb_sku_product_name",
          sort: "disabled",
          width: 150,
        },

        {
          label: "PKD",
          field: "pkd",
          sort: "disabled",
          width: 100,
        },
        {
          label: "CBU Code",
          field: "cbu_code",
          sort: "disabled",
          width: 100,
        },

        {
          label: "MRP",
          field: "mrp",
          sort: "disabled",
          width: 100,
        },
        {
          label: "Total Bins Occupied",
          field: "bin_count",
          sort: "disabled",
          width: 100,
        },
        {
          label: "Estimated Bins To Be Released",
          field: "",
          sort: "disabled",
          width: 100,
        },
      ],
      rows: this.state.data_for_consolidation,
    };

    const taskData = {
      columns: [/*{
          label: "Action",
          field: "cancel",
          sort: "asc",
          width: 100,
        },*/
		{
          label: "Task Id",
          field: "id",
		  sort: "disabled",
          width: 100,
        },
		{
          label: "Status",
          field: "status",
          sort: "disabled",
          width: 100,
        },
		{
          label: "Date",
          field: "date",
          sort: "disabled",
          width: 150,
        },
		{
          label: "Task Recommended",
          field: "tasks_recommended",
          sort: "disabled",
          width: 100,
        },
        {
          label: "Task Selected",
          field: "tasks_generated",
          sort: "disabled",
          width: 100,
        },
        {
          label: "Product Recommended",
          field: "product_recommended",
          sort: "disabled",
          width: 100,
        },
        {
          label: "Product Selected",
          field: "product_selected",
          sort: "disabled",
          width: 100,
        },
		{
          label: "Print",
          field: "Print",
          sort: "disabled",
          width: 100,
        },
		
      ],
      rows: this.state.data_for_task,
    };
    const selectedUser = [];
    const optionsUser = [];

    const uniqueZoneData = {};
    this.state.data_for_consolidation.map((item, index) => {
      let lbsku_pkd = item["lb_sku_id"] + "_" + item["pkd"];
      if (
        !uniqueZoneData[lbsku_pkd] &&
        this.state.selected[index] != false &&
        this.state.selected[index] != undefined
      ) {
        uniqueZoneData[lbsku_pkd] = {
          pkd: lbsku_pkd,
		  pkd_label: item["pkd"],
          id: item["lb_sku_id"],
          bin_count: item["bin_count"],
          items: [],
        };
      }
      if (
        this.state.selected[index] != false &&
        this.state.selected[index] != undefined
      ) {
        uniqueZoneData[lbsku_pkd].items.push(item);
      }
    });

    return (
      <div className="col-xl-12">
        <Card>
          <CardBody>
            <button
              color="primary"
              className="btn btn-primary btn-sm pull-left"
              
			  style={{fontWeight:'normal',textTransform:'capitalize',borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff',padding: "5px 25px",fontSize: "14px"}}
              onClick={this.showZoneDropdown}
              type="submit"
              disabled = {this.state.createTaskBtnDisabled ? "disabled":false}
            >
              Create Task
            </button>
            {this.state.createTaskBtnDisabled &&
			<p style={{textAlign: "left",paddingLeft: "22px"}}>Note : Please complete the pending task</p>
			}
          </CardBody>

          {this.state.showBinConsolidationTable && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header" style={{ border: "0px" }}>
                <button
                  color="primary"
                  className="btn btn-primary btn-sm pull-left"
                  style={{fontWeight:'normal',textTransform:'capitalize',borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff',padding: "5px 25px",fontSize: "14px"}}
                  onClick={this.handleAssignButton}
                  type="submit"
                  disabled={this.state.DisableAssignbutton}
                >
				  Assign
                </button>

				<button
                  color="primary"
                  className="btn btn-primary btn-sm pull-left"
                  style={{fontWeight:'normal',textTransform:'capitalize',borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff',padding: "5px 25px",fontSize: "14px",marginLeft:"10px"}}
                  onClick={this.onCancelHandler}
                  type="submit"
                >
                  Cancel
                </button>
              </div>
              <div style={{ marginTop: "20px" }}>
                <MDBDataTable
                  striped
                  bordered
                  hover
                  data={productData}
                  scrollX={true}
                  sorting={false}
                />
              </div>
            </CardBody>
          )}

          {this.state.showTaskTable && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <MDBDataTable
                  striped
                  bordered
                  hover
                  data={taskData}
                  scrollX={true}
                  sorting={false}
                />
              </div>
            </CardBody>
          )}
        </Card>
        <Modal
          isOpen={this.state.modalAssignUser}
          toggle={this.closeAssignModal}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 75 }}
            >
              <thead>
                <tr>
				<th>Product ID</th>
                  <th>PKD</th>
                  <th>Bin Count</th>
                  <th>Users</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(uniqueZoneData).length > 0 &&
                  _.map(uniqueZoneData, (item, key) => (
                    <tr key={key}>
					<td>{item.id}</td>
                      <td>{item.pkd_label}</td>
                      <td>{item.bin_count} </td>
                      <td>
                        <div className="form__form-group">
                          <div className="form__form-group-field">
                            <Select
                              isMulti
                              name={`multiSelect_${item.pkd}`}
                              value={selectedUser[item.pkd]}
                              onChange={(selectedOptions) =>
                                this.onChangeVal(selectedOptions, item.pkd)
                              }
                              options={this.state.optionsUser}
                              clearable={true}
                              closeOnSelect={true}
                              removeSelected={true}
                              className="react-select"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
            <button
                  className="modal_cancel"
                onClick={this.closeAssignModal}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.createTaskForConsolidation}
              >
                Assign and Proceed
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.showZone}
          toggle={this.showZoneDropdown}
          style={{ maxWidth: 580, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Select Zone
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <div
              className="form__form-group col-xl-12"
              style={{ display: "inline-flex", marginTop: "10px" }}
            >
              <span
                className="form__form-group-label col-xl-4"
                style={{
                  display: "inline",
                  paddingTop: 6,
                  paddingBottom: 6,
                }}
              >
                Select Zone
              </span>

              <div
                className="form__form-group-field col-xl-8"
                style={{ display: "inline", margin: "0px" }}
              >
                <Select
                  style={{ width: "100%" }}
                  options={this.state.options}
                  isMulti
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  allowSelectAll={true}
                  onChange={this.getSelectedZones}
                  value={this.state.selected_zone_option}
                />
              </div>
              
            </div>
			
			
			
			<ButtonToolbar className="modal__footer">
              <button
                  className="modal_cancel"
                onClick={this.showZoneDropdown}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                  backgroundColor: "#3ea3fc",
                }}
                className="modal_ok"
                onClick={this.fetchAllProducts}
              >
                Submit
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>
		
		<Modal
          isOpen={this.state.Successmodal}
          toggle={this.Successtoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.Successtoggle} />
           
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <h4>{this.state.reasonText}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.SuccesstoggleCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>

		<Modal isOpen={this.state.onCancel} toggle={this.state.onCancel}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.onCancel}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> Are you sure you want to cancel ? </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{  marginRight: 8 }}
              className="modal_cancel"
              onClick={this.onCancelHandler}
            >
              Cancel
            </button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.taskCancelHandler}
            >
              Ok
            </Button>
          </ButtonToolbar>
  </Modal>
      </div>
    );
  }
}

export default reduxForm({
  form: "Upload Master",
})(withTranslation("common")(HorizontalForm));